<template>
  <header class="things-header"
          @mouseleave="hideAll">

    <div class="header-left">
      <h1 v-if="!showTitle" class="title-header">
        <span v-if='activeOwned'>{{$t('things.headerList.owned')}}</span>
        <span v-else>{{$t('things.headerList.assigned')}}</span>
      </h1>
      <h1 v-else-if="showTitle && showMainHeading" class="title-header hint-cont">
      <span>
        <trim-item :string="dirName"
                   :width="30"></trim-item>
      </span>
      </h1>
      <div v-if="displayedNowThings.length" @click="toggleAll" class="check-group">
        <checkAllIcon />
        <span class="check-number">{{checkedThings.length}}</span>
        <span class="check-action">
          {{checkedThings.length === displayedNowThings.length || (this.checkedThings.length > 0) ? $t('projects.projectsList.deselectAll') : $t('projects.projectsList.selectAll')}}
        </span>
      </div>
    </div>

    <div class="header-right">
      <ul class="controls-list">
        <!--переход к настройкам мультивещи-->
        <li class="control-item"
            @click="goToVirtualSettings"
            v-if="isVirtualPage">
          <button type="button" class="control-btn-new hover-blue-new hint-cont">
            <edit-icon></edit-icon>
            <p class="btn-hint btn-hint_bottom">
              {{$t('things.goToVirtualSettings')}}
            </p>
          </button>
        </li>
        <!--удаление девайса насовсем-->
        <li class="control-item"
            @click="checkDel"
            v-if="showDelBtn && !isVirtualPage">
          <button type="button" class="control-btn-new hover-blue-new hint-cont">
            <del-icon></del-icon>
            <p class="btn-hint btn-hint_small btn-hint_bottom">
              {{$t('btns.users.delGroup')}}
            </p>
          </button>
        </li>
        <!--удаление из мультивещи-->
        <li class="control-item"
            v-if="showDelBtn && is3 && !isAssgined && routeId && isVirtualPage">
          <button type="button"
                  @click="checkDelVirtual"
                  class="control-btn-new hover-blue-new hint-cont">
            <del-icon></del-icon>
            <p class="btn-hint  btn-hint_bottom">
              {{$t('btns.users.delFromVirtual')}}
            </p>
          </button>
        </li>
        <!--объединение-->
        <li class="control-item"
            v-if="showMergeBtn && activeOwned">
          <button type="button"
                  @click="mergeVirtual"
                  class="control-btn-new hover-blue-new hint-cont">
            <folder-icon></folder-icon>
            <p class="btn-hint  btn-hint_bottom">
              {{$t('things.combine.combineMulti')}}
            </p>
          </button>
        </li>
        <!--добавление -->

        <li class="control-item"
            v-show="!isProjectPage"
            :disabled="isProjectPage"
            v-if="(is3 || isThingsPage) && !thingsPageAndAssigned && user.primary_role_id === user.active_role_id"
            @mouseleave="showAdd = false">
          <button type="button"
                  @mouseenter="showAdd = true"
                  class="btn-main-plus hover-blue_fill hint-cont">
            <plus-icon></plus-icon>
          </button>
          <add-list class="add-list"
                    :is-virtual="isVirtualPage"
                    v-show="showAdd"></add-list>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
  import {loaderMixin} from "../../../../../mixins/utils/loaderMixin"
  import {tokenAndRoute} from "../../../../../mixins/utils/tokenAndRoute"
  import {delItem} from "../../../../../mixins/delItem"
  import {delItem2} from "../../../../../mixins/delItem2"
  import {filters} from "../../../../../mixins/filters"
  import {toFormData} from "../../../../../mixins/utils/toFormData"
  import {combineThings} from "../../../../../mixins/things/combineThings"
  import {showOverlay} from "../../../../../mixins/utils/showOverlay"
  import chevrovIcon from '../../../../Svg/chevronIcon'
  import delIcon from '../../../../Svg/cart_control/delIcon'
  import folderIcon from '../../../../Svg/folderIconFill'
  import editVirtual from '../../../../Svg/things/editVirtual'
  import plusIcon from '../../../../Svg/plusIcon'
  import combineList from './combineList'
  import addList from './addList'
  import exitIcon from '../../../../Svg/sidebar/logout'
  import trimItem from '../../../../trimITem'
  import checkAllIcon from '../../../../Svg/projects/checkAllIcon'
  import editIcon from '../../../../../components/Svg/projects/editIcon'


  export default {
    name: 'thingListHeader',
    mixins: [loaderMixin, tokenAndRoute, delItem, delItem2, filters, toFormData, combineThings, showOverlay],
    components: {
      chevrovIcon,
      delIcon,
      folderIcon,
      plusIcon,
      combineList,
      addList,
      exitIcon,
      editVirtual,
      trimItem,
      checkAllIcon,
      editIcon
    },
    data() {
      return {
        showMenu: false,
        showCombine: false,
        showAdd: false,
      }
    },
    mounted() {},
    computed: {
      ...mapState({
        dirName: state => state.things.dirName,
        activeSection: state => state.things.activeSectionThings,
        checkedThings: state => state.things.checkedThingList,
        group: state => state.things.device,
        user: state => state.auth.user,
        mergeGroupId: state => state.things.mergeGroupId,
        isMergeGroup: state => state.things.isMergeGroup,
        mergeVirtualId: state => state.things.mergeVirtualId,
        isMergeVirtual: state => state.things.isMergeVirtual,
        allThingsFromGetOwned: state => state.things.allThingsFromGetOwned,
        displayedNowThings: state => state.things.displayedNowThings,
        virtualFlag: state => state.popups.virtualFlag,
      }),
      ...mapGetters({
        thingsFirstData: 'things/firstLevelThings',
      }),
      checkedThingsAll: {
        get() {
          return this.checkedThings
        },
        set(val) {
          this.setCheckedThings(val)
        }
      },
      isProjectPage() {
        return this.$route.name === 'ThingsInProject'
      },
      virtualAmongChecked() {
        return this.checkedThings.some(item => item.virtual === true)
      },
      groupPermission() {
        if (this.group) {
          return this.group.permission_level
        }
      },
      is1() {
        return this.groupPermission === 1
      },
      is2() {
        return this.groupPermission === 2
      },
      is3() {
        return this.groupPermission === 3 || this.groupPermission === 4
      },
      isThingsPage() {
        return (this.$route.name === 'things' && this.activeOwned) || this.$route.name === 'ThingsInProject' || this.$route.name === 'ThingsInProjectItem'
      },
      thingsPageAndAssigned() {
        return (this.$route.name === 'things' && this.activeAssigned)
      },
      isVirtualPage() {
        return this.$route.name === 'virtualThingList'
      },
      showTitle() {
        return this.$route.params.id
      },
      permissionCondition() {
        let permissionCondition = true;
        for (let i = 0; i < this.checkedThings.length; i++) {
          if (this.checkedThings[i].permission_level === 1) {
            permissionCondition = false;
            break;
          }
        };
        return permissionCondition
      },
      delPermission() {
        let condition = true;
        for (let i = 0; i < this.checkedThings.length; i++) {
          if (this.checkedThings[i].permission_level === 2) {
            condition = false;
            break;
          }
        };
        return condition
      },
      isAssgined() {
        let marker = false;
        for (let i = 0; i < this.checkedThings.length; i++) {
          if (!this.checkedThings[i].permissions) {
            marker = true;
            break
          }
        };
        return marker;
      },
      showDelBtn() {
        let lengthCondition = this.checkedThings.length > 0;
        return lengthCondition && this.permissionCondition && this.delPermission;
      },
      showMergeBtn() {
        let lengthCondition = this.checkedThings.length >= 2;
        return lengthCondition && this.permissionCondition;
      },
      activeOwned() {
        return this.activeSection === 'owned'
      },
      activeAssigned() {
        return this.activeSection === 'assigned'
      }
    },
    watch: {
      activeSection(val) {
        this.setCheckedThings([]);
      },
      mergeGroupId(val) {
        if (this.isMergeGroup) {
          this.checkedThings.forEach(item => {
            if (item.type === 'group') {
              this.updateGroupMerged(val, item)
            } else {
              this.updateThingMerged(val, item);
            }
          });

          this.clearMerged()
        }
      },
      mergeVirtualId(val) {
        if (this.isMergeVirtual) {
          this.updateVirtualMerged(val);

          this.clearMerged();
        }
      }
    },
    methods: {
      ...mapMutations({
        setActiveSection: 'things/SET_ACTIVE_SECTION',
        setCheckedThings: 'things/SET_CHECKED_THINGS_LIST',
        showAddThingPopup: 'popups/addThing/SET_SHOW',
        setType: 'popups/addThing/SET_TYPE',
        setMergeGroup: 'things/SET_MERGE_GROUP',
        setMergeVirtual: 'things/SET_MERGE_VIRTUAL',
        setChecked: 'things/SET_CHECKED_THINGS_LIST',
        showErrorMerge: 'things/SET_ERROR_MERGE_THING',
        setVirtualFlag: 'popups/SET_VIRTUAL_FLAG',
      }),
      ...mapActions({
        delThing: 'things/deleteDevice',
        getOwned: 'things/getDevices',
        // getAssigned: 'things/getAssignedDevices',
        updateDevice: 'things/updateDevice',
        getDevice: 'things/getDevice',
        getProjects: 'projects/getProjects'
      }),
      toggleAll() {
        if ((this.checkedThingsAll.length === this.displayedNowThings.length) || (this.checkedThings.length > 0)) {
          this.checkedThingsAll = []
        } else {
          this.displayedNowThings.forEach(item => {
            if (item.owner.user.primary_role_id === this.user.primary_role_id) {
              this.checkedThings.push(item)
            }
            this.setChecked(this.checkedThings)
          })
        }
      },
      mergeVirtual() {
        if (!this.disabledVirtualIfGroup) {
          this.showOverlay(true);
          this.showAddThingPopup(true);
          this.setType('multi');
          this.setMergeVirtual(true);
        }
      },
      async updateVirtualMerged(val) {
        for (let i = 0; i < this.checkedThings.length; i++) {
          let item = this.checkedThings[i]

          let updateObj = {
            device_id: item.id,
            parent_device_id: val,
            source: 1,
            source_connect_token: 1
          };
          let formData = this.toFormData(updateObj);
          this.updateThing(formData).catch(e => {
            this.showOverlay(true);
            this.showErrorMerge(true)
          });

          if (i === this.checkedThings.length - 1) {
            await this.reloadThings()
          }
        }
      },
      clearMerged() {
        this.setMergeGroup(false);
        this.setMergeVirtual(false);
        this.setChecked([]);
        this.updateThings();
      },
      goToVirtualSettings() {
        this.$router.replace(`/things/thing/${this.group.id}`)
      },
      showMainHeading() {
        if (this.$route.path === '/things') {
          return true
        } else {
          return false
        }
      },
      setOwned() {
        this.setActiveSection('owned');
        this.showMenu = false;
        localStorage.setItem('thing-section', 'owned')
      },
      setAdditional() {
        this.setActiveSection('assigned');
        this.showMenu = false;
        localStorage.setItem('thing-section', 'assigned')
      },
      hideAll() {
        this.showMenu = false;
        this.showCombine = false;
        this.showAdd = false;
      },
      checkDel() {
        let string = '';
        this.checkedThings.forEach((item, index) => {
          if (item.virtual) {
            this.setVirtualFlag(true)
          }
          if (index === this.checkedThings.length - 1) {
            string += `${item.name}`
          } else {
            string += `${item.name}, `
          }
        });

        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string);
        this.setNumberDel(1);
      },
      checkDelGroup() {
        let string = '';
        this.checkedThings.forEach(item => {
          string += `${item.name} `
        });

        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string);
        this.setNumberDel(2);
      },
      checkDelVirtual() {
        let string = '';
        this.checkedThings.forEach(item => {
          string += `${item.name} `
        });

        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string);
        this.setNumberDel(2);
      },
      deleteItems() {
        this.delThings().then(() => {
          this.reloadThings()
          this.hideLoader();
        });
      },
      deleteItems2(){
        if (!this.isVirtualPage) {
          this.delFromGroup();
        } else {
          this.delFromVirtual()
        }
      },
      async reloadThings() {
        await this.getProjects()

          await this.getOwned()

        if (this.showTitle) {
          if (!this.isVirtualPage) {
            await this.getGroup({token: this.token, id: this.routeId})
          } else {
            await  this.getDevice({token: this.token, id: this.routeId})
          }
        };
        this.setCheckedThings([]);
      },
      async delFromGroup() {
        this.showLoader();
        this.checkedThings.forEach(async item => {
          let type = item.type;
          let id = item.id
          if (type === 'group') {
            let data = {
              parent_group_id: 0,
              group_id: id
            };
            await this.updateGroup({data, token: this.token})
          } else {
            let data = {
              group_id: 0,
              device_id: id
            };
            await this.updateDevice({data, token: this.token})
          }
        });
        this.reloadThings();
        this.hideLoader()
      },
      async delFromVirtual() {
        this.showLoader();

        for (let i = 0; i < this.checkedThings.length; i++) {
          let item = this.checkedThings[i]
          let data = {
            // access_token: this.token,
            device_id: item.id,
            parent_device_id: -1
          };
          let formData = this.toFormData(data)
          this.updateDevice(formData)
          if (i === this.checkedThings.length - 1) {
            await this.reloadThings()
          }
        }

        this.reloadThings()
        this.hideLoader();
      },
      async delThings() {
        this.showLoader();

        for (let i = 0; i < this.checkedThings.length; i++) {
          let item = this.checkedThings[i]
          this.delThing(item.id)
          if (i === this.checkedThings.length - 1) {
            await this.reloadThings()
          }
        }


      },

    }
  }
</script>

<style lang="scss" scoped>
  .things-header {
    position: sticky;
    top: 90px;
    z-index: 1;
    background: $lightGrey;
    display: flex;
    justify-content: space-between;
  }

  .btn-hint {
    left: calc(50% + 5px) !important;
    transform: translateX(-50%);
  }

  .header-left {
    display: flex;
    align-items: center;
    position: relative;
    max-width: calc(100% - 280px);

    span {
      white-space: nowrap;
    }

  }

  .check-group {
    margin-left: 30px;
    min-width: 150px;
    //width: 200px;
    height: 40px;
    border: 1px solid #109CF1;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #109CF1;

    svg {
      margin-right: 10px;
      margin-left: 18px;
    }

    .check-number {
      margin-right: auto;
    }

    .check-action {
      cursor: pointer;
      margin: 0 18px;
    }
  }

  .title-header span {
    max-width: calc(100% - 280px);
    font-family: MSB, Arial, sans-serif;
    font-size: 18px;
    letter-spacing: 0.25px;
  }

  //.title {
  //  max-width: calc(100% - 280px);
  //  //width: 200px;
  //}
  //это еще тут нужно?
  //.thing-sections_list {
  //  background: white;
  //  position: absolute;
  //  min-width: 240px;
  //  border-radius: 8px;
  //  box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
  //  top: calc(100% + 20px);
  //  left: calc(100% - 30px);
  //
  //  button {
  //    width: 100%;
  //    padding: 20px;
  //    text-align: left;
  //    font-family: $msb;
  //    font-size: 12px;
  //    letter-spacing: .15px;
  //    color: $darkBlue;
  //  }
  //
  //  .active {
  //    button {
  //      color: $lightBlue;
  //    }
  //  }
  //}

  .header-right {
    margin-left: auto;
    display: flex;
    align-items: center;

    .controls-list {
      display: flex;
      margin: 0 -10px;
      align-items: center;
    }

    .control-item {
      padding: 20px 10px;
    }

    .btn-group-edit {
      max-height: 40px;
      margin-right: 20px;
      padding: 0 20px;
      white-space: nowrap;
    }
  }

  .control-item {
    position: relative;
    .control-btn-new {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .combine-list, .add-list {
    top: calc(100% - 10px);
    right: calc(100% - 50px);
  }

  .btn-main-plus {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
